<div class="title">
	<img
		src="/assets/images/closer-logos/closer-logo-full.webp"
		alt="Closer"
		class="login-header__logo"
	/>
	<h3>{{ label }}</h3>
	<p>{{ description }}</p>
</div>
<div class="legal">
	<small>&copy; Copyright {{ year }} LawLabs Inc.</small>
	<div class="flex flex-row gap-10 md:ml-3">
		<a
			class="font-bold cursor-pointer hover:text-green-600"
			[routerLink]="contactUrl"
			[testHook]="testHooks.ContactLink"
			>Contact</a
		>
		<a
			class="font-bold cursor-pointer hover:text-green-600"
			[routerLink]="legalUrl"
			[testHook]="testHooks.LegalLink"
			>Legal</a
		>
	</div>
</div>
<div class="content bg-grey-lightest">
	<ng-container *ngIf="!hideSocials">
		<button
			type="button"
			class="bg-blue-500 flex grow hover:bg-blue-600 items-center justify-center py-2 px-4 rounded text-teal-lightest w-full gap-1"
			(click)="connectToGoogle()"
			[testHook]="testHooks.ConnectToGoogleButton"
		>
			<img
				src="/assets/images/auth/
				google.webp"
				alt="Google G Letter Icon"
				class="h-4 w-4"
			/>
			<span>Continue with Google</span>
		</button>

		<div class="relative flex py-8 items-center">
			<div class="flex-grow border-t border-grey-lighter"></div>
			<span class="flex-shrink mx-4 uppercase">or</span>
			<div class="flex-grow border-t border-grey-lighter"></div>
		</div>
	</ng-container>

	<form
		class="flex flex-col gap-4"
		[formGroup]="formGroup"
		(ngSubmit)="onSubmit()"
	>
		<ng-content select="[form-content]"></ng-content>
		<ui-button
			*ngIf="!hideSubmitButton"
			type="submit"
			preset="HIGH_EMPHASIS"
			[loading]="loading"
			[disabled]="disabled"
			[label]="submitButtonText"
			class="flex"
			[fullWidth]="true"
			[testHook]="testHooks.AuthButton"
		>
		</ui-button>
	</form>

	<footer
		class="mt-5 md:mt-10 pt-3 border-t flex flex-col items-center md:items-start border-grey-lighter"
	>
		<ng-content #footer select="[footer-content]"></ng-content>
	</footer>
</div>
